import StickyTopBar from "@/components/StickyTopBar"
import HeroSectionBonus from "@/components/HeroSectionBonus"
import SocialProofCarousel from "@/components/SocialProofCarousel"
import PainSection from "@/components/PainSection"
import PromiseSection from "@/components/PromiseSection"
import LucyAISection from "@/components/LucyAISection"
import DetailedTestimonials from "@/components/DetailedTestimonials"
import WhyItWorks from "@/components/WhyItWorks"
import GuaranteeSection from "@/components/GuaranteeSection"
import ForWhoSection from "@/components/ForWhoSection"
import WhatYouGet from "@/components/WhatYouGet"
import UrgencySection from "@/components/UrgencySection"
import FinalCTABonus from "@/components/FinalCTABonus"
import FAQSection from "@/components/FAQSection"
import Footer from "@/components/Footer"
import StickyBottomBar from "@/components/StickyBottomBar"
import WhatsAppButton from "@/components/WhatsAppButton"

function ValeBonusPage() {
  return (
    <div className="min-h-screen">
      <StickyTopBar />
      <HeroSectionBonus />
      <SocialProofCarousel />
      <PainSection />
      <PromiseSection />
      <LucyAISection />
      <DetailedTestimonials />
      <WhyItWorks />
      <GuaranteeSection />
      <ForWhoSection />
      <WhatYouGet />
      <UrgencySection />
      <FinalCTABonus />
      <FAQSection />
      <Footer />
      <StickyBottomBar />
      <WhatsAppButton />
    </div>
  )
}

export default ValeBonusPage
